import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

export const AddEmail = styled(Row)`
  opacity: 0.85;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`;
